import React from "react";
import PropTypes from "prop-types";
import "./index.scss";
// import { HandWaving } from "phosphor-react";

const WelcomeHeader = ({ user, nickname }) => (
  <>
    {user ? (
      <div className="welcome-header">
        <h3 className="banner">
          Welcome, {user?.first_name} {user?.last_name}
        </h3>
      </div>
    ) : (
      <div className="welcome-header">
        <h3 className="banner">Welcome, {nickname}</h3>
      </div>
    )}
    {}
    {/* <div className="upcoming-season">
      <div className="headline">
        <p className="title">Upcoming season</p>
        <p className="icon">
          <HandWaving size={24} />
        </p>
      </div>
      <p className="content">
        Rice season is around the corner, Start monitoring your rice farms.
      </p>
    </div> */}
  </>
);

WelcomeHeader.propTypes = {
  user: PropTypes.string.isRequired,
  nickname: PropTypes.string.isRequired,
};

export default WelcomeHeader;
